import { getEnvironmentVariable } from '../services/env';
import { ROUTES } from './routes';

export const dashboard_tabs = {
  inProgress: 0,
  policyHolders: 1,
};

export const dashboard_slice_name = 'DASHBOARD';

export const dashboard_thunks = {
  DASHBOARD_GET_LATEST_APPLICATIONS: `${dashboard_slice_name}/fetchLatestApplications`,
  DASHBOARD_GET_APPLICATIONS: `${dashboard_slice_name}/fetchApplications`,
  DASHBOARD_GET_POLICYHOLDERS: `${dashboard_slice_name}/fetchPolicyHolders`,
};

export const dashboard_max_latest_applications = 10;

export const dashboard_appliant_status = {
  preQuote: 'pre-quote',
  underwriting: 'underwriting',
  decision: 'decision',
  quote: 'quote',
};

export const dashboard_sections_dev = [
  {
    name: 'Dashboard',
    url: ROUTES.DASHBOARD,
  },
  {
    name: 'Underwriting Qi',
    url: ROUTES.QI,
    target: '_blank',
  },
  {
    name: 'Literature',
    url: 'https://adviser.guardian1821.co.uk/tools-and-literature/literature/?dashboard=true',
    target: '_blank',
  },
  {
    name: 'Cover upgrade promise',
    url: 'https://adviser.marketing.staging.guardian1821.space10.co.uk/cover-upgrade-promise-checker/',
    target: '_blank',
  },
  {
    name: 'Need help?',
    url: '#need-help',
  },
];

export const dashboard_sections = [
  {
    name: 'Dashboard',
    url: ROUTES.DASHBOARD,
  },
  {
    name: 'Underwriting Qi',
    url: ROUTES.QI,
    target: '_blank',
  },
  {
    name: 'Literature',
    url: 'https://adviser.guardian1821.co.uk/tools-and-literature/literature/?dashboard=true',
    target: '_blank',
  },
  {
    name: 'Cover upgrade promise',
    url: 'https://adviser.guardian1821.co.uk/cover-upgrade-promise-checker/',
    target: '_blank',
  },
  {
    name: 'Need help?',
    url: '#need-help',
  },
];

export function getDashboardSections() {
  const isDev =
    getEnvironmentVariable('B2C_TENANT') !== 'guardian1821.b2clogin.com';
  if (isDev) {
    return dashboard_sections_dev;
  }
  return dashboard_sections;
}

export const MIN_SEARCH_TEXT = 2;
